"use strict";

exports.__esModule = true;
var _UpdateReportScreen = require("./UpdateReportScreen");
Object.keys(_UpdateReportScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateReportScreen[key]) return;
  exports[key] = _UpdateReportScreen[key];
});